/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import './common';
import './account_model';
import '../connect/v2/resources/error';
import './partial_account_model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "banking": {
        "nested": {
          "ListAccountsRequest": {
            "fields": {
              "owners": {
                "type": ".squareup.banking.Owner",
                "id": 1,
                "rule": "repeated"
              }
            }
          },
          "ListAccountsResponse": {
            "fields": {
              "accounts": {
                "type": ".squareup.banking.Account",
                "id": 1,
                "rule": "repeated"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              },
              "partialAccounts": {
                "type": ".squareup.banking.PartialAccount",
                "id": 3,
                "rule": "repeated"
              }
            }
          },
          "AccountService": {
            "methods": {
              "ListAccounts": {
                "requestType": ".squareup.banking.ListAccountsRequest",
                "responseType": ".squareup.banking.ListAccountsResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banking?.nested?.ListAccountsRequest && !$root.nested?.squareup?.nested?.banking?.nested?.ListAccountsResponse && !$root.nested?.squareup?.nested?.banking?.nested?.AccountService) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListAccountsRequest @ squareup/banking/account_service.proto at 15:1
 */
export const ListAccountsRequest = $root.lookupType('squareup.banking.ListAccountsRequest');
fixType(ListAccountsRequest);
Builder.createAndAttachToType(ListAccountsRequest);
/**
 * SOURCE ListAccountsResponse @ squareup/banking/account_service.proto at 24:1
 */
export const ListAccountsResponse = $root.lookupType('squareup.banking.ListAccountsResponse');
fixType(ListAccountsResponse);
Builder.createAndAttachToType(ListAccountsResponse);
/**
 * SOURCE AccountService @ squareup/banking/account_service.proto at 30:1
 */
export const AccountService = $root.lookupService('squareup.banking.AccountService');